import { LocaleD } from "db"
import * as t from "io-ts"

const TagTranslationDC = <T extends LocaleD>(locale: T) =>
  t.type({
    locale: t.literal(locale),
    name: t.string,
    slug: t.string,
  })

export type TagTranslationD = t.TypeOf<ReturnType<typeof TagTranslationDC>>

export const TagDC = t.type({
  translations: t.tuple([TagTranslationDC("en_ca"), TagTranslationDC("fr_ca")]),
})
